import React, { Component } from "react";
import styled, { css } from "react-emotion";
import { removeError } from "helpers";
import { withRedux } from "helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ErrorContainer = styled("div")`
  position: fixed;
  z-index: 9999;
  background: rgb(195, 74, 67, 0.9);
  height: 20%;
  width: 20%;
  right: 0;
  margin: 1%;
  padding: 1%;
  color: white;
  transition: 2s;
  cursor: pointer;
  -webkit-transition: 3s;
  display: ${(props) => (props.show ? "flex" : "none")};
  opacity: ${(props) => (props.show ? "1" : "0")};
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`;

const errorIcon = css`
  font-size: 2em;
  margin: auto;
`;

const errorMessage = css`
  height: 100%;
  width: 100%;
  padding: 0.2em;
  font-size: 1em;
  display: flex;
  align-items: center;
  margin-left: 0.5em;
`;

class Error extends Component {
  render() {
    let { error } = this.props;

    error = error ? error : "";

    if (typeof error !== "string") {
      error = "Oops something went wrong";
    }

    return (
      <ErrorContainer show={error} onClick={removeError}>
        <FontAwesomeIcon className={errorIcon} icon="times-circle" />
        <div className={errorMessage}>
          <p>{error}</p>
        </div>
      </ErrorContainer>
    );
  }
}

export default withRedux(Error);
